<template>
    <div>
        <div id="tabs" class="tab-bar">
            <ul>
                <li @click="selectedTab = 'email'">
                    <a href="#tabs-email"><i class="far fa-envelope"></i> E-mail</a>
                </li>

                <li @click="selectedTab = 'ticket'">
                    <a href="#tabs-ticket"><i class="fas fa-ticket"></i> Tickets</a>
                </li>

                <li @click="selectedTab = 'solicitations'">
                    <a href="#tabs-solicitations"><i class="fas fa-book"></i> Solicitações</a>
                </li>

                <!-- <li @click="selectedTab = 'tasks'">
                    <a href="#tabs-tasks"><i class="fas fa-tasks"></i> Tarefas</a>
                </li> -->

                <li @click="selectedTab = 'wpp-contacts'">
                    <a href="#tabs-wpp-contacts"><i class="fas fa-phone"></i> Contatos do WhatsApp</a>
                </li>

                <li @click="selectedTab = 'email-contacts'">
                    <a href="#tabs-email-contacts"><i class="fas fa-envelope"></i> Contatos de E-mail</a>
                </li>

                <li @click="selectedTab = 'notifications'">
                    <a href="#tabs-notifications"><i class="fas fa-bell"></i> Central de Notificações</a>
                </li>

                <li @click="selectedTab = 'quick-messages'">
                    <a href="#tabs-quick-messages"><i class="fas fa-bolt"></i> Mensagens Rápidas</a>
                </li>
            </ul>

            <div class="col-md-12" id="tabs-email" v-show="selectedTab == 'email'">
                <ConfigEmailsTable></ConfigEmailsTable>
            </div>

            <div class="col-md-12" id="tabs-ticket" v-show="selectedTab == 'ticket'">
                <ConfigTickets></ConfigTickets>
            </div>

            <div class="col-md-12" id="tabs-solicitations" v-show="selectedTab == 'solicitations'">
                <ConfigSolicitations></ConfigSolicitations>
            </div>

            <div class="col-md-12" id="tabs-tasks" v-show="selectedTab == 'tasks'">
                <ConfigTasks></ConfigTasks>
            </div>
            
            <div class="col-md-12" id="tabs-wpp-contacts" v-show="selectedTab == 'wpp-contacts'">
                <ConfigWppContacts></ConfigWppContacts>
            </div>
            
            <div class="col-md-12" id="tabs-email-contacts" v-show="selectedTab == 'email-contacts'">
                <ConfigEmailContacts></ConfigEmailContacts>
            </div>
            
            <div class="col-md-12" id="tabs-notifications" v-show="selectedTab == 'notifications'">
                <ConfigNotifications></ConfigNotifications>
            </div>
            
            <div class="col-md-12" id="tabs-quick-messages" v-show="selectedTab == 'quick-messages'">
                <ConfigQuickMessages></ConfigQuickMessages>
            </div>
        </div>
    </div>
</template>

<script>
import ConfigEmailsTable from "../emails/ConfigEmailsTable.vue";
import ConfigTickets from "../tickets/ConfigTickets.vue";
import ConfigTasks from "../tasks/ConfigTasks.vue";
import ConfigSolicitations from "../solicitation/ConfigSolicitations.vue";
import ConfigWppContacts from "../wpp/ConfigWppContacts.vue";
import ConfigEmailContacts from "../emails/ConfigEmailContacts.vue";
import ConfigNotifications from "../notifications/ConfigNotifications.vue";
import ConfigQuickMessages from "../quick-messages/ConfigQuickMessages.vue";

export default {
    name: "Settings",
    components: {
        ConfigEmailsTable,
        ConfigTickets,
        ConfigSolicitations, 
        ConfigTasks,
        ConfigWppContacts,
        ConfigEmailContacts,
        ConfigNotifications,
        ConfigQuickMessages,
    },
    data() {
        return {
            selectedTab: "email",
        }
    }
}
</script>

<style>
.tab-bar {
    margin-bottom: 20px;
}
</style>